import clsx from "clsx";
import { LinkProps, Link as LinkRouter } from "react-router-dom";

interface Props extends LinkProps {
  variant?: "contained" | "outlined";
  color?: "primary";
  disabled?: boolean;
}

export default function Link(props: Props) {
  const {
    variant = "contained",
    color = "primary",
    className,
    children,
    disabled,
    ...rest
  } = props;
  return (
    <LinkRouter
      className={clsx(
        "inline-flex w-full items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-center font-bold transition-colors",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
        disabled && "pointer-events-none opacity-50",
        {
          "bg-primary text-white hover:bg-primaryDark":
            variant === "contained" && color === "primary",
          "border-2 border-primary bg-transparent text-primary hover:bg-primaryLight":
            variant === "outlined" && color === "primary",
        },
        className
      )}
      aria-disabled={disabled}
      {...rest}
    >
      {children}
    </LinkRouter>
  );
}
